import type * as React from "react";

import { cn } from "./cn";
import { inputVariants, labelRecipe } from "./recipes";

/*
 * A form field (company.css `.ct-field`): label, control, hint or error, 6px
 * apart. The control takes `inputVariants()`; its edge is `border-input`
 * (3:1 on the white field), focus is the forest edge with a soft forest ring and
 * `aria-invalid` turns it danger. A field error says how to fix the value.
 */

function Field({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="field"
      className={cn("grid min-w-0 content-start gap-1.5", className)}
      {...props}
    />
  );
}

function FieldLabel({ className, ...props }: React.ComponentProps<"label">) {
  return (
    <label
      data-slot="field-label"
      className={cn(labelRecipe, className)}
      {...props}
    />
  );
}

/** Help under the control: 13px, muted. */
function FieldHint({ className, ...props }: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="field-hint"
      className={cn(
        "text-compact leading-[18px] text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}

/** What is wrong with the value and how to fix it: 14px (content a person must read), danger. */
function FieldError({ className, ...props }: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="field-error"
      className={cn(
        "text-sm leading-[18px] font-medium text-danger",
        className,
      )}
      {...props}
    />
  );
}

export { Field, FieldError, FieldHint, FieldLabel, inputVariants };
